module.exports = __webpack_public_path__ + "static/media/testUpdate.57097ed7.jpg";